import { createAsyncThunk } from "@reduxjs/toolkit";
import { ScheduleInterview } from "helpers/api_method";

export const scheduleInterview = createAsyncThunk("interview/scheduleInterview", async (data: any) => {
    const response = await ScheduleInterview(data.resume_id, data.interview_data);
    return response;
});
